/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
    <path d="M5.83331 8.33337H14.1666" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.83331 11.6666H14.1666" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 18.3333C14.6024 18.3333 18.3334 14.6023 18.3334 9.99996C18.3334 5.39759 14.6024 1.66663 10 1.66663C5.39765 1.66663 1.66669 5.39759 1.66669 9.99996C1.66669 14.6023 5.39765 18.3333 10 18.3333Z" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
